import { useMutation } from '@tanstack/react-query';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { type BaseOptions, type CreateSearchAlertV4Request } from '@ev-tech/search-modules-api';

export const SearchAlertFrequency = {
  INSTANTLY: 'instantly',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  NEVER: 'never',
} as const;

export type SearchAlertFrequency = (typeof SearchAlertFrequency)[keyof typeof SearchAlertFrequency];

type CreateAlertParams = {
  payload: CreateSearchAlertV4Request;
  options: BaseOptions;
};

type CreateSearchAlertResponse = {
  emailId?: string | null;
  searchAlertId?: string | null;
};

type CreateSearchAlertSuccess = {
  status: 'success';
  data: CreateSearchAlertResponse;
};

type CreateSearchAlertResultFailure = {
  status: 'error';
  message?: string;
};

type CreateSearchAlertResult = CreateSearchAlertSuccess | CreateSearchAlertResultFailure;

export const useSearchAlert = () => {
  const { api, events } = useAppContext();

  return useMutation<CreateSearchAlertResult, Error, CreateAlertParams>({
    mutationFn: async (createAlertParams: CreateAlertParams) =>
      await api.createSearchAlert(createAlertParams.payload, createAlertParams.options),
    onError: (error) => events?.onError?.(error),
  });
};
